/**
 * AllPill — ProviderFilter's "All" pill. Built from ProviderBadge's own box
 * (PROVIDER_BADGE_BASE), so it shares one baseline with the tracker pills.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';

import { PROVIDER_BADGE_BASE } from '@/components/ui/ProviderBadge';
import { cn } from '@/lib/utils';

interface Props {
  on: boolean;
  onClick: () => void;
}

export const AllPill: FC<Props> = ({ on, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    aria-pressed={on}
    className={cn(
      PROVIDER_BADGE_BASE,
      'transition-colors',
      on
        ? 'border-foreground bg-foreground text-background'
        : 'border-transparent text-muted-foreground hover:text-foreground',
    )}
  >
    All
  </button>
);

export default AllPill;
